<template>
  <div>
    <el-form label-position="top">
      <el-form-item>
        <img
          src="/wechat.ico"
          height="45px"
          alt="微信登录"
          loading="lazy"
          title="微信登录"
        />
        <span v-if="user.wechat_connected"
          >微信已绑定，<el-link
            @click="disconnectWechat()"
            icon="el-icon-delete"
            >取消微信绑定</el-link
          >
        </span>
        <a
          v-else
          title="微信登录"
          href="https://open.weixin.qq.com/connect/qrconnect?appid=wx957a277b11a4e554&redirect_uri=https://www.99huaren.com/wechat/connect&response_type=code&scope=snsapi_login&state=user_id#wechat_redirecdt"
        >
          连接微信
        </a>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapState(["user"])
  },
  methods: {
    ...mapMutations(["loginWithToken", "setLoading"]),
    disconnectWechat: function() {
      this.$http
        .delete("/wechat")
        .then(res => {
          console.log(res);
          this.$message({
            showClose: true,
            type: "success",
            message: "取消绑定成功"
          });
          this.user.wechat_connected = false;
          if (this.token) {
            this.loginWithToken(this.token);
          }
          this.setLoading(false);
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: "error",
            message: "取消绑定未成功，请稍后再试"
          });
          this.setLoading(false);
        });
    }
  }
};
</script>
